<template>
  <router-view/>
</template>

<script>
export default {
  name: "AdminShipping"
}
</script>
